<template>
  <modal
    ref="resultsPDFConfigModal"
    template="neutral"
    ref-name="resultsPDFConfigModal"
    :icon-enabled="false"
    :close-button-enabled="true"
    class="results-config-modal"
  >
    <button
      class="close-button btn-transparent"
      @click="closeModal"
    >
      <md-icon>clear</md-icon>
    </button>
    <div
      v-if="!loading"
      class="results-config-modal__content"
    >
      <h2>Configurações de impressão:</h2>

      <h3 class="results-config-modal__report-section-title">
        Cabeçalho do Laudo
      </h3>

      <p>Imprimir Logomarca</p>
      <md-radio
        v-model="newPrintConfig.logo"
        :md-value="true"
      >
        Sim
      </md-radio>
      <md-radio
        v-model="newPrintConfig.logo"
        :md-value="false"
      >
        Não
      </md-radio>

      <md-input-container v-if="!newPrintConfig.logo">
        <label for="margem_superior">Distância do Cabeçalho do Laudo (Milímetros - 0mm a 50mm) </label>
        <md-input
          id="margem_superior"
          v-model="newPrintConfig.margem_superior"
          type="number"
          @change.native="handleInputChange($event.target.value)"
        />
      </md-input-container>

      <!-- <p>Acrescentar Matrícula ao Nome do Paciente</p>
      <md-radio v-model="newPrintConfig.mat" :mdValue="true">Sim</md-radio>
      <md-radio v-model="newPrintConfig.mat" :mdValue="false">Não</md-radio>

      <p>Acrescentar Sexo ao Laudo</p>
      <md-radio v-model="newPrintConfig.sexo" :mdValue="true">Sim</md-radio>
      <md-radio v-model="newPrintConfig.sexo" :mdValue="false">Não</md-radio> -->

      <!-- <md-input-container>
        <label for="idd">Acrescentar Idade ou Data de Nascimento</label>
        <md-select v-model="newPrintConfig.idd" id="idd">
          <md-option value="nenhum">Nenhum</md-option>
          <md-option value="idade">Idade</md-option>
          <md-option value="nascimento">Data de nascimento</md-option>
        </md-select>
      </md-input-container> -->

      <!-- <p>Adicionar idade por extenso</p>
      <md-radio v-model="newPrintConfig.iddext" :mdValue="true">Sim</md-radio>
      <md-radio v-model="newPrintConfig.iddext" :mdValue="false">Não</md-radio>

      <p>Adicionar documento do paciente</p>
      <md-radio v-model="newPrintConfig.docp" :mdValue="true">Sim</md-radio>
      <md-radio v-model="newPrintConfig.docp" :mdValue="false">Não</md-radio>

      <p>Remover Instituição</p>
      <md-radio v-model="newPrintConfig.ins" :mdValue="true">Sim</md-radio>
      <md-radio v-model="newPrintConfig.ins" :mdValue="false">Não</md-radio> -->

      <!-- <p>Mostrar OS Lis no Laudo</p>
      <md-radio v-model="newPrintConfig.lis" :mdValue="true">Sim</md-radio>
      <md-radio v-model="newPrintConfig.lis" :mdValue="false">Não</md-radio>

      <p>Remover Solicitação</p>
      <md-radio v-model="newPrintConfig.sol" :mdValue="true">Sim</md-radio>
      <md-radio v-model="newPrintConfig.sol" :mdValue="false">Não</md-radio> -->

      <p>Nome da Impressão da Instituição</p>
      <md-radio
        v-model="newPrintConfig.nomeInstituicao"
        md-value="nome"
      >
        Razão Social
      </md-radio>
      <md-radio
        v-model="newPrintConfig.nomeInstituicao"
        md-value="fantasia"
      >
        Nome fantasia
      </md-radio>

      <!-- <h3 class="results-config-modal__report-section-title">Corpo do Laudo</h3>

      <p>Mostrar Data de Liberação do Exame</p>
      <md-radio v-model="newPrintConfig.liberadoEm" :mdValue="true">Sim</md-radio>
      <md-radio v-model="newPrintConfig.liberadoEm" :mdValue="false">Não</md-radio>

      <p>Imprimir Valor de Referência</p>
      <md-radio v-model="newPrintConfig.ref" :mdValue="true">Sim</md-radio>
      <md-radio v-model="newPrintConfig.ref" :mdValue="false">Não</md-radio>

      <p>Mostrar Linha Separadora Entre Exames</p>
      <md-radio v-model="newPrintConfig.sep" :mdValue="true">Sim</md-radio>
      <md-radio v-model="newPrintConfig.sep" :mdValue="false">Não</md-radio> -->

      <h3 class="results-config-modal__report-section-title">
        Rodapé do Laudo
      </h3>

      <!-- <md-input-container>
        <label for="minf">Distância do Rodapé do Laudo (Milímetros)</label>
        <md-input v-model="newPrintConfig.minf" id="minf" type="number"></md-input>
      </md-input-container> -->

      <!-- <p>Mostrar Liberado Por</p>
      <md-radio v-model="newPrintConfig.lib" :mdValue="true">Sim</md-radio>
      <md-radio v-model="newPrintConfig.lib" :mdValue="false">Não</md-radio>

      <p>Imprimir Assinatura</p>
      <md-radio v-model="newPrintConfig.ass" :mdValue="true">Sim</md-radio>
      <md-radio v-model="newPrintConfig.ass" :mdValue="false">Não</md-radio> -->

      <!-- <md-input-container>
        <label for="obsa">Observação da Assinatura</label>
        <md-input v-model="newPrintConfig.obsa" id="obsa" type="text"></md-input>
      </md-input-container> -->

      <p>Mostrar Rodapé</p>
      <md-radio
        v-model="newPrintConfig.rodape"
        md-value="Default"
      >
        Padrão
      </md-radio>
      <md-radio
        v-model="newPrintConfig.rodape"
        md-value="Customizado"
      >
        Customizado
      </md-radio>
      <md-radio
        v-model="newPrintConfig.rodape"
        md-value="Margem"
      >
        Margem
      </md-radio> 

      <md-input-container v-if="newPrintConfig.rodape === 'Margem'">
        <label for="minf">Distância do Rodapé do Laudo (Milímetros - 0mm a 50mm)</label>
        <md-input
          id="minf"
          v-model="newPrintConfig.minf"
          type="number"
          @change.native="handleInputChange('minf', $event.target.value)"
        />
      </md-input-container>
      
      <p>Mostrar QRCode</p>
      <md-radio
        v-model="newPrintConfig.mostrarQrCode"
        :md-value="true"
      >
        Sim
      </md-radio>
      <md-radio
        v-model="newPrintConfig.mostrarQrCode"
        :md-value="false"
      >
        Não
      </md-radio>

      <div class="results-config-modal__actions">
        <button
          class="btn-bordered"
          @click="closeModal"
        >
          Fechar
        </button>
        <button
          class="btn btn-primary"
          @click="saveConfig"
        >
          Salvar alterações
        </button>
      </div>
    </div>

    <div
      v-else
      class="results-config-modal__spinner-box"
    >
      <Spinner />
    </div>
  </modal>
</template>
<script>
import Spinner from '@/components/common/Spinner'

import resultPDFService from '@/api/resultsPDF'
import notify from '@/api/notification'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'ResultsConfigModal',
  components: {
    Spinner
  },
  data: () => ({
    loading: false,
    newPrintConfig: {}
  }),
  computed: {
    ...mapGetters(['printConfig'])
  },
  methods: {
    ...mapActions(['getPrintConfig']),
    openModal() {
      this.$refs.resultsPDFConfigModal.open()
      this.newPrintConfig = this.printConfig
    },
    saveConfig() {
      this.loading = true
      resultPDFService
        .savePrintConfig(this.newPrintConfig)
        .then(res => {
          this.loading = false
          this.closeModal()

          notify({
            title: 'SUCESSO:',
            message: 'Configurações atualizadas com sucesso!'
          })
        })
        .catch(err => {
          console.error('erro -->', err)
          this.loading = false

          notify({
            title: 'AVISO:',
            message: 'Não foi possível salvar as configurações!'
          })
        })
    },
    closeModal() {
      this.$refs.resultsPDFConfigModal.close()
      this.getPrintConfig()
    },
    handleInputChange(margem_superior) {
      if (margem_superior < 0) {
        this.newPrintConfig.margem_superior = 0
      } else if (margem_superior > 50) {
        this.newPrintConfig.margem_superior = 50
      }
    }
  }
}
</script>
<style lang="scss">
.results-config-modal {
  font-family: 'Exo 2', sans-serif !important;

  .md-dialog {
    width: 90%;
    max-width: 640px;
    // height: 620px;
    // min-height: 620px;
  }

  .md-dialog-title {
    display: none;
  }

  .md-dialog-content {
    padding: 0;
  }

  .close-button {
    z-index: 90;
    top: 15px;
    right: 24px;
  }

  .loader {
    width: 80px;
    height: 80px;
  }

  &__spinner-box {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 620px;
  }

  &__content {
    padding: 30px;

    h2 {
      color: #7a7a7a;
      margin-bottom: 24px;
    }

    .md-theme-default.md-radio .md-radio-container:after {
      background-color: #7f1a54;
    }

    .md-theme-default.md-radio.md-checked .md-radio-container {
      border-color: #7f1a54;
    }

    .md-radio {
      margin: 8px 16px 16px 0;
    }
  }

  &__report-section-title {
    font-size: 12px;
    letter-spacing: 0.1px;
    text-align: left;
    color: #7f1a54;
    font-weight: 600;
    text-transform: uppercase;
    margin: 4px 0 10px;
    border-bottom: 1px solid #7f1a54;
  }

  &__actions {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: 18px;

    button {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 15px;
      border-radius: 5px;
      background: #7f1a54;
      font-size: 14px;
      font-weight: 600;
      font-family: 'Exo 2', sans-serif !important;
      text-transform: uppercase;
      height: 40px;
      cursor: pointer;
    }

    .btn-bordered {
      background: none;
      border: 2px solid #7f1a54;
      border-radius: 3px;
      color: #7f1a54;
      margin-right: 12px;
    }
  }
}
</style>
